<template>
  <va-layout v-if="breakpoint.lgUp" class="h-screen bg-[var(--va-background-secondary)]">
    <template #left>
      <router-link
        class="bg-[var(--va-background-border)] h-full flex items-center justify-center"
        style="width: 35vw"
        to="/"
        aria-label="Visit homepage"
      >
        <img src="https://multimarcas.online/images/logo2.png" />
      </router-link>
    </template>
    <template #content>
      <main class="h-full flex items-center justify-center mx-auto max-w-[420px]">
        <router-view />
      </main>
    </template>
  </va-layout>

  <va-layout v-else class="h-screen bg-[var(--va-background-secondary)]">
    <template #content>
      <div class="p-4">
        <main class="h-full flex flex-row items-center justify-start mx-auto max-w-[420px]">
          <div class="flex flex-col items-start">
            <router-link class="py-4" to="/" aria-label="Visit homepage">
              <img class="mb-2" src="https://multimarcas.online/images/logo2.png" />
            </router-link>
            <router-view />
          </div>
        </main>
      </div>
    </template>
  </va-layout>
</template>

<script lang="ts" setup>
import { useBreakpoint } from 'vuestic-ui'
// import VuesticLogo from '../components/VuesticLogo.vue'

const breakpoint = useBreakpoint()
</script>
